<template>
  <div class="detail-root">
    <el-dialog
      custom-class="detail-dlg"
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="918px"
      @closed="onClosed"
      v-loading="loading"
    >
      <div class="content form-content">
        <div class="row mutlti" v-if="showAuditOpinion">
          <div class="tip">审核意见</div>
          <div class="value input fill">
            <span class="opinion">{{ auditOpinion }}</span>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">名称</div>
          <div class="value input fill">
            <el-input
              size="small"
              maxlength="20"
              v-model="posterName"
              :disabled="true"
            ></el-input>
          </div>
        </div>
        <div class="row mutlti big">
          <div class="tip">资料内容</div>
          <div class="value input fill">
            <ossFileUpload
              v-model="picFileList"
              style="margin-bottom: 10px"
              :disabled="true"
            >
            </ossFileUpload>
          </div>
        </div>
        <div class="row mutlti big" style="margin-top: 12px">
          <div class="tip">视频内容</div>
          <div class="value input fill">
            <ossFileUpload
              v-model="videoFileList"
              style="margin-bottom: 10px"
              :disabled="true"
            >
            </ossFileUpload>
          </div>
        </div>
        <div class="row mutlti big" style="margin-top: 12px">
          <div class="tip">商品信息</div>
          <div class="value">
            <div class="goods-info" v-if="goodsInfo">
              <el-image
                :src="goodsInfo.image ? goodsInfo.image : avater"
                lazy
                style="width: 100px; height: 100px"
              />
              <div class="txt-info">
                <div class="name">{{ goodsInfo.name }}</div>
                <div class="factory">{{ goodsInfo.factory }}</div>
                <div class="factory">{{ goodsInfo.specification }}</div>
                <div class="factory">{{ goodsInfo.approvalNumber }}</div>
                <div class="factory">商品编码：{{ goodsInfo.goodsCode }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button v-if="!isLook" size="small" @click="handleCheck(2)"
          >驳回</el-button
        >
        <el-button
          v-if="!isLook"
          size="small"
          type="primary"
          @click="handleCheck(1)"
          >审核通过</el-button
        >
      </div>
    </el-dialog>

    <reasonDlg ref="refGReasonDlg" @onConfirm="handleAuditFail" />
  </div>
</template>

<script>
import ossFileUpload from "@/components/ossFileUpload";
import { getOssSrcFileName } from "@/utils/oss";
import reasonDlg from "./reason.vue";
import avater from "/public/img/default.png";
import {
  examineSalesScienceProfile,
  querySalesScienceProfileById,
} from "@/api/salesControl/academic";

export default {
  components: { ossFileUpload, reasonDlg },
  data() {
    return {
      action: 1, //1 审核  3 查看
      dialogVisible: false,
      posterId: null,
      loading: false,
      maxFileCount: 9,
      /**
       * {
          fileName: "check_2024060511154657176078.png",
          name: "check_2024060511154657176078.png",
          url: "https://eshop-develop.oss-cn-hangzhou.aliyuncs.com/goods/check_2024060511154657176078.png",
        },
       */
      picFileList: [],
      picFileExt: ".jpg, .png, .pdf,.bmp,.jpeg",
      videoFileList: [],
      videoFileExt:
        ".avi, .flv, .mp4, .3gp, .rm, .rmvb, .mkv, .vob, .wmv, .asf, .mov, .mpeg, .mwv",

      avater: avater,

      btnType: "add",
      auditStatus: "", //审核状态
      auditOpinion: "", //审核意见
      posterName: "", //名称
      goodsInfo: null, //选择的商品
    };
  },
  computed: {
    title() {
      let txt = "资料";
      if (this.action === 3) {
        txt = `查看${txt}`;
      } else {
        txt = `审核${txt}`;
      }
      return txt;
    },
    isLook() {
      return this.action === 3;
    },
    showAuditOpinion() {
      return this.isLook && this.auditStatus === 2;
    },
  },
  methods: {
    open(options = null) {
      if (options) {
        this.action = options.action ? options.action : 1;
        this.posterId = options.posterId ? options.posterId : null;
        this.getDetail();
      }
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    onClosed() {
      this.reset();
    },
    reset() {
      this.action = 1;
      this.posterId = "";
      this.posterName = "";
      this.auditStatus = "";
      this.auditOpinion = "";
      this.picFileList = [];
      this.videoFileList = [];
      this.goodsInfo = null;
    },
    onRemoveHandlerForPic(file) {
      let index = this.picFileList.indexOf(file);
      this.picFileList.splice(index, 1);
    },
    onRemoveHandlerForVideo(file) {
      let index = this.videoFileList.indexOf(file);
      this.videoFileList.splice(index, 1);
    },
    handleSelectGoods() {
      this.$refs.refGoodsDailog.init(this.goodsInfo, "", "选择商品");
    },
    didSelectItem(item) {
      this.goodsInfo = item;
    },
    getDetail() {
      if (this.posterId) {
        this.loading = true;
        querySalesScienceProfileById({ id: this.posterId })
          .then((data) => {
            this.loading = false;
            if (data) {
              this.posterName = data.posterName;

              this.auditStatus = data.auditStatus; //审核状态
              this.auditOpinion = data.auditOpinion; //审核意见

              this.goodsInfo = {
                id: data.goodsId,
                name: data.goodsName,
                factory: data.factory,
                specification: data.specification,
                goodsCode: data.goodsCode,
                image: data.goodsImage,
                approvalNumber: data.approvalNumber,
              };
              if (Array.isArray(data.details)) {
                let picFileList = [];
                let videoFileList = [];
                data.details.forEach((item) => {
                  if (item) {
                    /**{name:"",url:""} */
                    const urlObj = this.parseToUploadUrl(item.contentUrl);
                    if (urlObj && urlObj.name && urlObj.url) {
                      if (item.type === "DATA_CONTENT") {
                        picFileList.push(urlObj);
                      } else if (item.type === "VIDEO_CONTENT") {
                        videoFileList.push(urlObj);
                      }
                    }
                  }
                });

                this.picFileList = picFileList;
                this.videoFileList = videoFileList;
              }
            }
          })
          .catch((ex) => {});
      }
    },
    handleCheck(auditStatus) {
      if (auditStatus === 1) {
        this.doAudit(auditStatus);
      } else if (auditStatus === 2) {
        this.auditFail();
      }
    },
    doAudit(auditStatus, auditOpinion, cb) {
      const data = {
        id: this.posterId,
        auditStatus: auditStatus,
        auditOpinion: auditOpinion ? auditOpinion : "",
      };
      examineSalesScienceProfile(data).then((res) => {
        if (res) {
          this.$emit("onRefresh");
          cb && cb();
          this.dialogVisible = false;
        }
      });
    },
    auditFail() {
      this.$refs.refGReasonDlg.open();
    },
    handleAuditFail(params) {
      this.doAudit(2, params.reason, () => {
        this.$refs.refGReasonDlg.close();
      });
    },
    getUploadFileUrl(item) {
      let netUrl = "";
      if (item) {
        if (item.url) {
          //可能是已经上传过的
          netUrl = item.url;
        } else if (
          //服务器返回过来的
          item.response &&
          item.response.data &&
          item.response.data.url
        ) {
          netUrl = item.response.data.url;
        }
      }
      return netUrl;
    },
    parseToUploadUrl(newUrl) {
      if (newUrl) {
        const name = getOssSrcFileName(newUrl); //newUrl.split("/");
        return { name: name, url: newUrl };
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-root {
  ::v-deep .detail-dlg {
    .form-content {
      .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 0;
        box-sizing: border-box;

        &.mutlti {
          align-items: flex-start;
        }

        &.contine {
          padding-top: 0;
        }

        &.big {
          .tip {
            height: 32px;
            line-height: 32px;
          }
        }

        .tip {
          width: 5em;
          text-align: right;
          font-size: 14px;
          font-weight: 400;
          text-align: right;
          color: #262626;
        }

        .value {
          margin-left: 16px;

          &.input {
            width: 204px;

            ::v-deep .el-date-editor.el-input,
            ::v-deep .el-date-editor.el-input__inner {
              width: 100%;
            }
          }

          &.fill {
            flex: 1;
            width: 0;
          }

          .small-tip {
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #8c8c8c;

            &.warning {
              color: #e6a23c;
            }
          }

          &.mutlti {
            flex: 1;
            width: 0;
            display: flex;

            &.v {
              flex-direction: column;

              .in-row {
                &:not(:first-child) {
                  margin-top: 8px;
                }
              }
            }
          }

          .flag-block {
            width: 100%;
            background: #fafafa;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding: 8px 16px 16px 16px;
            box-sizing: border-box;
            flex-wrap: wrap;

            .flag-title {
              font-size: 14px;
              font-weight: 400;
              color: #262626;
              margin-right: 8px;
            }

            & > * {
              margin-top: 8px;
            }
          }
        }

        .in-row {
          .value {
            margin-left: 0;
          }
        }
      }

      .opinion {
        color: #f00;
      }

      .goods-info {
        display: inline-flex;
        align-items: center;
        margin-right: 24px;

        .txt-info {
          display: flex;
          flex-direction: column;
          margin-left: 12px;
          .name {
            font-size: 16px;
            font-weight: 600;
            color: var(--color-26);
          }
          .factory {
            color: var(--color-59);
            font-size: 14px;
            margin-top: 3px;
          }
        }
      }
    }

    .el-upload {
      width: auto;
    }
    .el-dialog__body {
      max-height: 60vh;
      overflow-y: auto;
      min-height: 240px;
    }
  }
}
</style>
